import { BaseContainerModel } from '../../base-container.model';
import { bl_b2b_process_tracking_ipo_xdo_igrn_hdr_RowClass } from '../../../dbschema/index';

export class ProcessTrackingIpoXdoIgrnContainer extends BaseContainerModel {
  bl_b2b_process_tracking_ipo_xdo_igrn_hdr: bl_b2b_process_tracking_ipo_xdo_igrn_hdr_RowClass = new bl_b2b_process_tracking_ipo_xdo_igrn_hdr_RowClass();
}
